import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Avatar, Typography } from '@material-ui/core';
import SecureLS from 'secure-ls';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content',
    width: '100%',
    minWidth: 0
  },
  avatar: {
    margin: theme.spacing(0.5),
    width: 40,
    height: 40,
    fontSize: 16,
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main
  },
  name: {
    marginTop: theme.spacing(0.5),
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  email: {
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
}));

const Profile = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  const secureLS = new SecureLS({encodingType: 'aes', encryptionSecret: process.env.AES_KEY});

  const user = {
    name: secureLS.get('cloud_license.name'),
    initials: secureLS.get('cloud_license.initials'),
    bio: secureLS.get('cloud_license.email'),
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Avatar
        // alt="Person"
        className={classes.avatar}
        // src={user.avatar}
      >
        {user.initials}
      </Avatar>
      <Typography
        className={classes.name}
        variant="h5"
      >
        {user.name}
      </Typography>
      <Typography
        className={classes.email}
        variant="body2"
      >
        {user.bio}
      </Typography>
    </div>
  );
};

Profile.propTypes = {
  className: PropTypes.string
};

export default Profile;
